
import axios from "axios";
import apiClient from "./base.service";

export default {
    async login(email, password) {
        const params = new URLSearchParams();
        params.append('email', email);
        params.append('password', password);
        return await axios.post(`/api/login`, params)
    },
    async register(data) {
        return await apiClient.post(`/me`, data);
    },
    async create(data) {
        return await apiClient.post(`/user`, data);
    },
    async getMe() {
        return await apiClient.get(`/me`)
    },
    async logout() {
        return await apiClient.get(`/logout`)
    },
    async index(withShifts = false) {
        let param = '';
        if(withShifts) {
            param = '?withShifts=1';
        }
        return await apiClient.get(`/user${param}`);
    },
    async usersWithoutTicket(event_id) {
        return await apiClient.get(`/user?withoutTicket=${event_id}`)
    },
    async get(id) {
        return await apiClient.get(`/user/${id}`);
    },
    async update(id, data) {
        return await apiClient.put(`/user/${id}`, data);
    },
    async comment(id, comment) {
        return await apiClient.put(`/user/${id}/comment`, {comment})
    },
    async updateMe(data) {
        return await apiClient.put(`/me`, data);
    },
    async connect(id, ticket) {
        return await apiClient.get(`/user/${id}/connect/${ticket}`);
    },
    async weHaveNewShirts() {
        return await apiClient.put(`/action/resetshirts`);
    },
    async confirm(data) {
        return await apiClient.post(`/me/confirm/phone`, data);
    },
    async confirmEmail(body) {
        return await apiClient.post(`/me/confirm/email`, body);
    },
    async resendEmail() {
        return await apiClient.post(`/me/resend/email`);
    },
    async resendSms(email) {
        return await apiClient.get(`/me/resend/sms?email=${email}`);
    },
    async broadcast(mo) {
        return await apiClient.post(`/action/broadcast/sms`, mo);
    },
    async broadcastMail(mo) {
        return await apiClient.post(`/action/broadcast/mail`, mo);
    },
    async requestPasswordChange(data) {
        return await apiClient.post(`/me/requestpasswordreset`, data);
    },
    async resetPassword(data) {
        return await apiClient.post(`/me/resetpassword`, data)
    },
    async checkNtfy() {
        return await apiClient.get(`/me/checkntfy`)
    }
}
